import { qtyProxy } from "../../../..";
import {apiUrls, errorMessages} from "../../../assets/config";
import { checkToLoadScriptFoOdoo, getCurrentCanvas, setLoader } from "../../../helpers/helper";
import { selectedTextBoxStyleHelper } from "../../productDetail/textController";
import WebFont from "webfontloader";

export async function getFontData(): Promise<void> {
  if (checkToLoadScriptFoOdoo()) {
    return;
 }
  try {
    const response = await fetch(apiUrls.googleFontApi);
    const data = await response.json();
    qtyProxy["fontList"] = data?.items?.slice(0,100);

    WebFont.load({
      google: {
        families: data?.items?.slice(0,100).map((font) => font.family),
      },
      active: function () {
      },
    });
  } catch (error) {
    alert(errorMessages.SERVER_ERROR);
    setLoader(false);
  }
}

export function applyGoogleFontHandler(font, activeObject): void {
  qtyProxy["addedFontList"] = qtyProxy?.addedFontList || ["Times New Roman"];

  if (!font && !activeObject) return;


  setLoader(true);
  activeObject.set("fontFamily", font);
  selectedTextBoxStyleHelper("fontFamily", activeObject);
  getCurrentCanvas().fire("object:modified");
   getCurrentCanvas().renderAll();
  setLoader(false);
}
